import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    private apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = environment.url;
    }

    private getHeaders(): HttpHeaders {
        const token = localStorage.getItem('token');
        let headers = new HttpHeaders({});

        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        return headers;
    }

    get(endpoint: string): Observable<any> {
        return this.http.get(`${this.apiUrl}${endpoint}`, {
            headers: this.getHeaders()
        }).pipe(
            catchError(this.handleError)
        );
    }

    getBlob(endpoint: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}${endpoint}`, {
            headers: this.getHeaders(),
            responseType: 'blob'
        }).pipe(
            catchError(this.handleError)
        );
    }

    post(endpoint: string, data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}${endpoint}`, data, {
            headers: this.getHeaders()
        }).pipe(
            catchError(this.handleError)
        );
    }

    put(endpoint: string, data: any): Observable<any> {
        return this.http.put(`${this.apiUrl}${endpoint}`, data, {
            headers: this.getHeaders()
        }).pipe(
            catchError(this.handleError)
        );
    }

    patch(endpoint: string, data: any): Observable<any> {
        return this.http.patch(`${this.apiUrl}${endpoint}`, data, {
            headers: this.getHeaders()
        }).pipe(
            catchError(this.handleError)
        );
    }

    delete(endpoint: string, data?: any): Observable<any> {
        let options: any = {
            headers: this.getHeaders()
        };

        if (data) {
            options.body = data;
        }

        return this.http.delete(`${this.apiUrl}${endpoint}`, options).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: any): Observable<never> {
        console.error('API Error:', error);

        let errorMessage = 'Error desconocido';

        if (error.error instanceof ErrorEvent) {
            // Error del lado del cliente
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Error del lado del servidor
            if (error.error && error.error.message) {
                errorMessage = error.error.message;
            } else if (error.error && Array.isArray(error.error.errors) && error.error.errors[0]?.error) {
                // Forma usada por endpoints tipo stamp-bulk: { errors: [{ id, error }] }
                errorMessage = error.error.errors[0].error;
            } else if (error.status) {
                switch (error.status) {
                    case 400:
                        errorMessage = 'Solicitud incorrecta';
                        break;
                    case 401:
                        errorMessage = 'No autorizado';
                        break;
                    case 403:
                        errorMessage = 'Prohibido';
                        break;
                    case 404:
                        errorMessage = 'Recurso no encontrado';
                        break;
                    case 500:
                        errorMessage = 'Error interno del servidor';
                        break;
                    default:
                        errorMessage = `Error ${error.status}`;
                }
            }
        }

        return throwError(errorMessage);
    }
}
